<template>
  <!--
https://api.nobiasinvesting.com/auth/register
{"first_name" : "John", "last_name" : "Cena", "email" : "johncena@hotmail.com", "password" : "asdf1234", "role" : 0, "status" : true, "pin" : "1234", "parked" : false, "trial_expiry" : "" }
  --->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{(!portfolio)? 'Add':'Edit'}} Portfolio</strong>
        </div>
        <div class="col-md-2">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div>
        <div class="mb5"></div>
        <form class="form-horizontal" @onsubmit.prevent action>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group" :class="{'has-error': validation.hasError('name')}">
                <label class="form-control-label">Name</label>
                <input type="hidden" class="form-control" v-model="pid" />
                <input
                  type="text"
                  class="form-control inmarginbtm"
                  placeholder="Portfolio Name"
                  value
                  v-model="name"
                />
                <div class="error">{{ validation.firstError('name') }}</div>
              </div>
            </div>
            
            <div class="col-md-6">
              <div class="form-group">
                <label class="col-form-label">Status</label>
                <select class="form-control" name="portfolio-status" v-model="status">
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-control-label">Description</label>
                <!-- <input
                  type="text"
                  class="form-control"
                  placeholder="Description "
                  v-model="Description"
                /> -->
                <vue-ckeditor id="description" v-model="description" :config="config" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="form-control-label">Long Description</label>
                <!-- <textarea
                  type="text"
                  class="form-control"
                  placeholder="Long Description "
                  v-model="longDescription"
                ></textarea>-->
                <vue-ckeditor id="longDescription" v-model="longDescription" :config="config" />
              </div>
            </div>
          </div>
          <div class="raw">
            <div class="col-md-12" v-if="errors && errors.length>0">{{errors}}</div>
          </div>
          <div class="form-group pull-right">
            <button type="button" @click="addPortfolio" class="btn btn-info" v-if="!portfolio">Add</button>
            <button
              type="button"
              @click="updatePortfolio"
              class="btn btn-info"
              v-if="portfolio"
            >Update</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// import vform from "@/components/vform";
import http from "@/lib/http";
// import PinCheck from "@/components/PinCheck.vue";
import SimpleVueValidation from "simple-vue-validator";
var Validator = SimpleVueValidation.Validator;
import VueCkeditor from "vue-ckeditor2";

export default {
  props: ["portfolio"],
  components: { VueCkeditor },
  created() {
    console.log("existing", this.portfolio);
    if (this.portfolio) {
      this.pid = this.portfolio._id;
      this.name = this.portfolio.name;
      this.description = this.portfolio.description;
      this.longDescription = this.portfolio.long_description;
      this.status = this.portfolio.status;
    }
  },
  data() {
    return {
      portfolioDetails: {},
      pid: "",
      name: "",
      description: "",
      longDescription: "",
      status: 1,
      errors: [],
      submitted: false,
      config: {
        toolbar: [
          {
            name: "snddocument",
            items: [
              "Source",
              "-",
              "Save",
              "NewPage",
              "DocProps",
              "Preview",
              "Print",
              "-",
              "Templates"
            ]
          },
          { name: "clipboard", items: ["Undo", "Redo"] },
          {
            name: "editing",
            items: [
              "Find",
              "Replace",
              "-",
              "SelectAll",
              "-",
              "SpellChecker",
              "Scayt"
            ]
          },
          {
            name: "forms",
            items: [
              "Form",
              "Checkbox",
              "Radio",
              "TextField",
              "Textarea",
              "Select",
              "Button",
              "ImageButton",
              "HiddenField"
            ]
          },
          "/",
          {
            name: "basicstyles",
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "RemoveFormat"
            ]
          },
          {
            name: "paragraph",
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl"
            ]
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              // "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe"
            ]
          },
          { name: "styles", items: ["Styles", "Format", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "tools", items: ["Maximize", "ShowBlocks"] }
        ]
      }
    };
  },
  validators: {
    name: function(value) {
      return Validator.value(value).required();
    },
    description: function(value) {
      return Validator.value(value).required();
    },
    longDescription: function(value) {
      return Validator.value(value).required();
    }
  },
  methods: {
    addPortfolio() {
      var _this = this;
      this.submitted = true;
      this.$validate().then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.portfolioDetails = {
            _id: this.pid,
            name: this.name,
            description: this.description,
            long_description: this.longDescription,
            status: parseInt(this.status)
          };
          console.log("register details", this.portfolioDetails);
          http.post("addPortfolio", this.portfolioDetails, function(
            error,
            response
          ) {
            if (!error) {
              console.log("response", response);
              if (response.status === "success") {
                _this.$toastr.success("Added Successfully!", "", {});
                _this.clearForm();
              } else {
                _this.errors = response.message;
              }
            } else {
              console.log("error", error);
            }
          });
        }
      });
    },
    clearForm() {
      this.portfolioDetails = {};
      this.pid = "";
      this.name = "";
      this.description = "";
      this.longDescription = "";
      this.status = 1;
    },
    updatePortfolio() {
      var _this = this;
      this.submitted = true;
      console.log("User Status", this.status);
      this.$validate(["name"]).then(success => {
        // console.log('on success ' + success)
        if (success) {
          this.portfolioDetails = {
            _id: this.pid,
            name: this.name,
            description: this.description,
            long_description: this.longDescription,
            status: parseInt(this.status)
          };
          console.log("User details", this.portfolioDetails);
          http.post("addPortfolio", this.portfolioDetails, function(
            error,
            response
          ) {
            if (!error) {
              console.log("response", response);
              if (response.ok === 1) {
                _this.$toastr.success("Updated Successfully!", "", {});
                _this.clearForm();
                _this.$router.push({ name: "listing" });
                // setTimeout(() => { _this.$router.push({name: "user-listing"}) }, 100);
              } else {
                _this.errors = response.message;
              }
            } else {
              console.log("error", error);
            }
          });
        }
      });
    }
  },
  watch: {
    portfolio: function(value) {
      this.pid = value._id;
      this.name = value.name;
      this.description = value.description;
      this.longDescription = value.long_description;
      this.portfolio = value.portfolio;
      this.status = value.status;
    }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/portfolios/add-portfolios.vue